import { Candidate } from './Model/Candidate';
import { JobCenterModelInterface } from './Model/JobCenterModelInterface';
import { JobVacancy } from './Model/JobVacancy';

export enum Type {
    Candidate = 'candidate',
    JobVacancy = 'job_vacancy',
}

export function typeFromModel(model: JobCenterModelInterface): Type {
    if (model instanceof Candidate) {
        return Type.Candidate;
    }
    if (model instanceof JobVacancy) {
        return Type.JobVacancy;
    }
    throw new TypeError('Could not detect type for model');
}
